/* eslint-disable */
import 'select2';
import 'node-waves';
import './material_theme/material';

$(document).ready(function() {
  $('.form-group .fg-toggled').each(function(i,e) {
    $(e).removeClass('fg-toggled').addClass('fg-populated');
  });


  if ($.fn.select2) {
    // single-select dropdowns
    $('.select2-ready').select2({ minimumResultsForSearch: Infinity });
    // multi-select dropdowns
    $('.select2-multiple-ready').select2({
      placeholder: function() {
        return $(this).data('placeholder');
      },
      allowClear: true
    });
  }

  $('.fg-select2 .select2 input').addClass('form-control');

  $('body').on('change', '.fg-select2 select', function () {
    var p = $(this).closest('.form-group, .input-group');
    var i = $(this).val();

    if (p.hasClass('fg-float')) {
      if (!i || i.length === 0) {
        $(this).closest('.fg-line').removeClass('fg-populated');
      } else {
        $(this).closest('.fg-line').addClass('fg-populated');
      }
    }
    else {
      $(this).closest('.fg-line').removeClass('fg-populated');
    }
  });
  $('body').on('blur', '.form-control', function(){
    var p = $(this).closest('.form-group, .input-group');
    var i = p.find('.form-control').val();

    if (p.hasClass('fg-float')) {
      if (!i || i.length == 0) {
        $(this).closest('.fg-line').removeClass('fg-populated');
      } else {
        $(this).closest('.fg-line').addClass('fg-populated');
      }
      $(this).closest('.fg-line').removeClass('fg-toggled');
    }
  });
  $('.flash-autohide').delay(2000).fadeOut();
  $('#skipLink').on('keydown', function (event) {
    if (event.keyCode === 13 || event.keyCode === 32) {
      $('#content-focus').focus();
    }
  }).click(function(e){
    e.preventDefault();
    $('#content-focus').focus();
  });
});
